/**
 * @file A component with render prop providing photo cache
 * thumbnails - easier to use for generic purposes than the withPhotoUploadCache HOC.
 */

import PropTypes from 'prop-types';

import withPhotoUploadCache from '../../apps/pro/components/hoc/withPhotoUploadCache';

const propTypes = {
  id: PropTypes.string.isRequired,
  thumbs: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  ),
  render: PropTypes.func.isRequired,
};

const PhotoUploadCache = withPhotoUploadCache(({ thumbs, render }) =>
  render(thumbs),
);

PhotoUploadCache.propTypes = propTypes;

export default PhotoUploadCache;
